import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import RadioButtons from 'further-ui/components/RadioButtons';
import { BulletinAttachmentMode } from 'further-types/lp/bulletin-update';
import { bulletinAttachmentModeOptions } from '../constants';
import { BulletinUpdateFormValues } from '../schema';

const UniqueAttachmentInstructions = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(theme.spacingSizes.sm),
}));

const ExampleFileName = styled('span')(({ theme }) => ({
  color: theme.palette.grey[600],
  textDecoration: 'underline',
  textDecorationStyle: 'dotted',
}));

type Props = {
  control: Control<BulletinUpdateFormValues>;
};

const AttachmentSettings: FC<Props> = ({ control }) => {
  return (
    <Controller
      control={control}
      name="attachmentMode"
      render={({ field }) => (
        <>
          <Typography variant="h6" color="grey.600">
            Attachment settings
          </Typography>
          <RadioButtons
            direction="row"
            optionSpacing="xs"
            name={field.name}
            value={field.value}
            onChange={field.onChange}
            options={bulletinAttachmentModeOptions}
          />
          {field.value === BulletinAttachmentMode.UniquePerInvestor ? (
            <UniqueAttachmentInstructions variant="body2">
              To send unique attachments, include the investor’s full name in
              the file name exactly as it appears in the vehicle. Example:{' '}
              <ExampleFileName>
                ADAM BRANSTON investor-update.pdf
              </ExampleFileName>
              . Use spaces (no symbols) between name words and include middle
              names where relevant. Only files with an exact investor name match
              will be detected and sent.
            </UniqueAttachmentInstructions>
          ) : null}
        </>
      )}
    />
  );
};

export default AttachmentSettings;
